export default __webpack_public_path__ + "static/media/LenkradschonerTOPTEX2.2c89cf55.jpg";